<template lang="pug">
  nuxt
</template>

<script>
const meta = {
  title: 'Mitra B2B',
  description: 'Shopping from distributors is safer with Bukalapak B2B Partners!',
  image: 'https://mitrab2b.bukalapak.com/android-chrome-192x192.png',
};

export default {
  head() {
    return {
      title: meta.title,
      link: [
        { hid: 'manifest', rel: 'manifest', href: '/b2b/site.webmanifest' },
        { hid: 'shortcut-icon', rel: 'shortcut icon', href: '/b2b/favicon.ico', type: 'image/x-icon' },
        { hid: 'apple-touch-icon', rel: 'apple-touch-icon', sizes: '180x180', href: '/b2b/apple-touch-icon.png' },
        { hid: 'icon-32', rel: 'icon', type: 'image/png', sizes: '32x32', href: '/b2b/favicon-32x32.png' },
        { hid: 'icon-16', rel: 'icon', type: 'image/png', sizes: '16x16', href: '/b2b/favicon-16x16.png' },
        { hid: 'mask-icon', rel: 'mask-icon', href: '/b2b/safari-pinned-tab.svg', color: '#ffffff' },
      ],
      meta: [
        { hid: 'description', name: 'description', content: meta.description },

        { hid: 'twitter:image', property: 'twitter:image', content: meta.image },
        { hid: 'twitter:title', property: 'twitter:title', content: meta.title },
        { hid: 'twitter:description', property: 'twitter:description', content: meta.description },

        { hid: 'og:title', property: 'og:title', name: 'og:title', content: meta.title },
        { hid: 'og:site_name', property: 'og:site_name', content: meta.title },
        { hid: 'og:description', property: 'og:description', name: 'og:description', content: meta.description },
        { hid: 'og:type', property: 'og:type', name: 'og:type', content: 'website' },
        { hid: 'og:image', property: 'og:image', content: meta.image },

        { hid: 'msapplication-TileColor', name: 'msapplication-TileColor', content: '#ffffff' },
        { hid: 'apple-mobile-web-app-title', name: 'apple-mobile-web-app-title', content: meta.title },
        { hid: 'msapplication-config', name: 'msapplication-config', content: '/b2b/browserconfig.xml' },
        { hid: 'msapplication-tooltip', name: 'msapplication-tooltip', content: meta.title },

        { hid: 'google', name: 'google', content: 'notranslate, nositelinkssearchbox' },
        { hid: 'theme-color', name: 'theme-color', content: '#ffffff' },
      ],
    };
  },
};
</script>

<style lang="scss">
html,
body,
#__nuxt,
#__layout {
  width: 100%;
  height: 100%;
}

body {
  margin: 0;
}
</style>
